import React from "react";
import { Fade } from "react-awesome-reveal";
import Logo from "../../images/Logo/logo.svg";
import {
  Amantrika_link,
  Email_link,
  instagram_link,
} from "../../utils/constant";
import "./footer.scss";

/**
 * One footer design for every theme: the logo, a short note, "Create Now" and the
 * social links, centred. White by default; a theme recolours it through the CSS
 * variables in footer.scss (Royal Mahal makes it night blue).
 */
const Footer = (props) => {
  const redirectToAmantrikaHome = () => {
    window.open(Amantrika_link, "_blank");
  };

  return (
    <footer className={`amantrika-footer ${props.footerClass || ""} section`}>
      <div className="amantrika-footer__upper">
        <Fade delay={300} duration={1600} triggerOnce="true">
          <img className="amantrika-footer__logo" src={Logo} alt="Amantrika" />
        </Fade>
        <p className="amantrika-footer__text">Did you like our beautiful invitation?</p>
        <p className="amantrika-footer__text">
          Create your perfect invitation with ease on our website today!
        </p>
        <button
          type="button"
          onClick={redirectToAmantrikaHome}
          className="amantrika-footer__btn"
        >
          Create Now
        </button>
      </div>
      <div className="amantrika-footer__lower">
        <a
          className="amantrika-footer__icon"
          href={instagram_link}
          target="_blank"
          rel="noreferrer"
          aria-label="Instagram"
        >
          <i className="ti-instagram"></i>
        </a>
        <a
          className="amantrika-footer__icon"
          href={Email_link}
          target="_blank"
          rel="noreferrer"
          aria-label="Email"
        >
          <i className="ti-email"></i>
        </a>
      </div>
    </footer>
  );
};

export default Footer;
